var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1.25C5.66797 1.25 1.75 5.16797 1.75 10C1.75 14.832 5.66797 18.75 10.5 18.75C15.332 18.75 19.25 14.832 19.25 10C19.25 5.16797 15.332 1.25 10.5 1.25ZM13.9473 12.6895L13.3887 13.4512C13.3765 13.4678 13.3612 13.4818 13.3436 13.4924C13.326 13.5031 13.3065 13.5102 13.2862 13.5132C13.2659 13.5163 13.2451 13.5154 13.2252 13.5104C13.2052 13.5055 13.1864 13.4966 13.1699 13.4844L9.93945 11.1289C9.91933 11.1145 9.90297 11.0954 9.89175 11.0733C9.88054 11.0512 9.87479 11.0267 9.875 11.002V5.625C9.875 5.53906 9.94531 5.46875 10.0312 5.46875H10.9707C11.0566 5.46875 11.127 5.53906 11.127 5.625V10.459L13.9121 12.4727C13.9824 12.5215 13.998 12.6191 13.9473 12.6895Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.59eee965a8cd711d50bca119c7c95106.svg";
export { ForwardRef as ReactComponent };